<div class="row">
  <div class="col-md-12 checkbox d-flex justify-content-end mb-3 mt-4">
    <label>
      <input
        id="selectAllPermissionsLobbys"
        [(ngModel)]="permissionLobby.selectAllPermissionLobby.Selected"
        class="cc-filter-checkbox set-pointer-events"
        type="checkbox"
        kendoCheckBox
        [disabled]="isUkgDefaultGroup || isViewOnly || !disabledSelectAllLobby"
        (change)="valueChangeByselectAllPermissionsLobby($event)"
      />
      {{ "_Permission_Select_All_Lobby_Permissions_" | translate }}
    </label>
  </div>
  <ng-container *ngIf="isLoaded">
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Admin_General_Title_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="generalselectall"
                [(ngModel)]="permissionLobby.General.selectAll"
                (change)="selectAllLobby()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionLobby.General.editLobby.Enabled ||
                  !permissionLobby.General.viewCentralViews.Enabled ||
                  !permissionLobby.General.forceSignOutUsers.Enabled ||
                  !permissionLobby.General.accessAllQueues.Enabled
                "
              />

              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="46"
                  name="editLobby"
                  (change)="onLobbyItemChange()"
                  [(ngModel)]="permissionLobby.General.editLobby.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionLobby.General.editLobby.Enabled"
                />
                {{ permissionLobby.General.editLobby.DisplayName | translate }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  id="47"
                  name="viewCentral"
                  (change)="onLobbyItemChange()"
                  [(ngModel)]="
                    permissionLobby.General.viewCentralViews.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionLobby.General.viewCentralViews.Enabled"
                />
                {{
                  permissionLobby.General.viewCentralViews.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  id="48"
                  name="viewCentral"
                  (change)="onLobbyItemChange()"
                  [(ngModel)]="
                    permissionLobby.General.forceSignOutUsers.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionLobby.General.forceSignOutUsers.Enabled
                  "
                />
                {{
                  permissionLobby.General.forceSignOutUsers.DisplayName
                    | translate
                }}
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="checkbox mt-1">
              <label>
                <input
                  id="106"
                  name="accAllLobby"
                  (change)="onLobbyItemChange()"
                  [(ngModel)]="permissionLobby.General.accessAllQueues.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionLobby.General.accessAllQueues.Enabled"
                />
                {{
                  permissionLobby.General.accessAllQueues.DisplayName
                    | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Checklists_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="chelistSelectAll"
                [(ngModel)]="permissionLobby.Checklist.selectAll"
                (change)="selectAllChecklist()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionLobby.Checklist.viewChecklist.Enabled ||
                  !permissionLobby.Checklist.addChecklist.Enabled ||
                  !permissionLobby.Checklist.editCheckList.Enabled ||
                  !permissionLobby.Checklist.deleteChecklist.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="49"
                  name="viewchecklst"
                  (change)="onChecklistItemChange()"
                  [(ngModel)]="permissionLobby.Checklist.viewChecklist.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionLobby.Checklist.viewChecklist.Enabled"
                />
                {{
                  permissionLobby.Checklist.viewChecklist.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="50"
                    name="addchklist"
                    (change)="onChecklistItemChange()"
                    [(ngModel)]="
                      permissionLobby.Checklist.addChecklist.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.Checklist.addChecklist.Enabled ||
                      !permissionLobby.Checklist.viewChecklist.Selected
                    "
                  />
                  {{
                    permissionLobby.Checklist.addChecklist.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="51"
                    name="edChecklist"
                    (change)="onChecklistItemChange()"
                    [(ngModel)]="
                      permissionLobby.Checklist.editCheckList.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.Checklist.editCheckList.Enabled ||
                      !permissionLobby.Checklist.viewChecklist.Selected
                    "
                  />
                  {{
                    permissionLobby.Checklist.editCheckList.DisplayName
                      | translate
                  }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="52"
                    name="delchklist"
                    (change)="onChecklistItemChange()"
                    [(ngModel)]="
                      permissionLobby.Checklist.deleteChecklist.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.Checklist.deleteChecklist.Enabled ||
                      !permissionLobby.Checklist.viewChecklist.Selected
                    "
                  />
                  {{
                    permissionLobby.Checklist.deleteChecklist.DisplayName
                      | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">{{ "_General_LWA_Text_" | translate }}</h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="lwaSAll"
                [(ngModel)]="permissionLobby.Lwa.selectAll"
                (change)="selectAllLwa()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionLobby.Lwa.lwaView.Enabled ||
                  !permissionLobby.Lwa.lwaAdd.Enabled ||
                  !permissionLobby.Lwa.lwaEdit.Enabled ||
                  !permissionLobby.Lwa.lwaDelete.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="53"
                  name="delchklist"
                  (change)="onLwaItemChange()"
                  [(ngModel)]="permissionLobby.Lwa.lwaView.Selected"
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="!permissionLobby.Lwa.lwaView.Enabled"
                />
                {{ permissionLobby.Lwa.lwaView.DisplayName | translate }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="54"
                    name="lwaadd"
                    (change)="onLwaItemChange()"
                    [(ngModel)]="permissionLobby.Lwa.lwaAdd.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.Lwa.lwaAdd.Enabled ||
                      !permissionLobby.Lwa.lwaView.Selected
                    "
                  />
                  {{ permissionLobby.Lwa.lwaAdd.DisplayName | translate }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="55"
                    name="lwaedit"
                    (change)="onLwaItemChange()"
                    [(ngModel)]="permissionLobby.Lwa.lwaEdit.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.Lwa.lwaEdit.Enabled ||
                      !permissionLobby.Lwa.lwaView.Selected
                    "
                  />
                  {{ permissionLobby.Lwa.lwaEdit.DisplayName | translate }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input
                    id="56"
                    name="lwadel"
                    (change)="onLwaItemChange()"
                    [(ngModel)]="permissionLobby.Lwa.lwaDelete.Selected"
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.Lwa.lwaDelete.Enabled ||
                      !permissionLobby.Lwa.lwaView.Selected
                    "
                  />
                  {{ permissionLobby.Lwa.lwaDelete.DisplayName | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_General_Text_Messages_Text_" | translate }}
          </h6>

          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="txtCSAll"
                [(ngModel)]="permissionLobby.TextConfiguration.selectAll"
                (change)="selectAllTextConfiguration()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionLobby.TextConfiguration.textConfigView.Enabled ||
                  !permissionLobby.TextConfiguration.textConfigEdit.Enabled ||
                  !permissionLobby.TextConfiguration.textConfigEnable.Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="checkbox">
              <label>
                <input
                  id="57"
                  name="txtCView"
                  (change)="onTextConfigurationItemChange()"
                  [(ngModel)]="
                    permissionLobby.TextConfiguration.textConfigView.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionLobby.TextConfiguration.textConfigView.Enabled
                  "
                />
                {{
                  permissionLobby.TextConfiguration.textConfigView.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="58"
                    name="txtCEdit"
                    (change)="onTextConfigurationItemChange()"
                    [(ngModel)]="
                      permissionLobby.TextConfiguration.textConfigEdit.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionLobby.TextConfiguration.textConfigEdit
                        .Enabled ||
                      !permissionLobby.TextConfiguration.textConfigView.Selected
                    "
                  />
                  {{
                    permissionLobby.TextConfiguration.textConfigEdit.DisplayName
                      | translate
                  }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="checkbox mt-1">
              <label>
                <input
                  id="59"
                  name="txtCEna"
                  (change)="onTextConfigurationItemChange()"
                  [(ngModel)]="
                    permissionLobby.TextConfiguration.textConfigEnable.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionLobby.TextConfiguration.textConfigEnable.Enabled
                  "
                />
                {{
                  permissionLobby.TextConfiguration.textConfigEnable.DisplayName
                    | translate
                }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
